export default "__VITE_ASSET__Cio70jKO__"